window.addEventListener('DOMContentLoaded', function (e) {
  jQuery(function ($) {
    function clearErrors() {
      $('.validation-error').addClass('hidden');
      $('.validation-error').text('');
    }

    function displayError(scope, error) {
      let errorElement = scope.siblings('.validation-error');
      errorElement.toggleClass('hidden', !!!error);
      if (error) {
        errorElement.text(error);
      }
    }

    async function validateInputs() {
      try {
        let nameInput = $('input#full_name');
        let emailInput = $('input#email');

        if (!nameInput.val())
          throw {
            element: nameInput,
            message: 'Please enter your name',
          };

        if (!emailInput.val())
          throw {
            element: emailInput,
            message: 'Please enter your email',
          };

        return {
          name: nameInput.val(),
          email: emailInput.val(),
          referrer: "PDP",
          subscribeToNewsletter: $('input#subscribe').is(':checked'),
          cardId: $('.brochure-newsletter-subscription').attr(
            'data-brochure-id',
          ),
        };
      } catch (e) {
        clearErrors();
        displayError(e.element, e.message);
        throw e;
      }
    }

    $('.brochure-newsletter-subscription .download-brochure-cta').off('click');
    $('.brochure-newsletter-subscription .download-brochure-cta').on(
      'click',
      function (e) {
        e.preventDefault();

        validateInputs()
          .then(function (goodInputs) {
            return fetch(window.theme.webhooks.brochureSubscription, {
              method: 'POST',
              body: JSON.stringify(goodInputs),
            }).then((resp) => resp.json());
          })
          .then((data) => {
            if (data.status === 'success') {
              $('.form-wrapper').text(
                'Check your email inbox for the download link!',
              );
            }
          })
          .catch((e) => {
            console.log(e);
          });
      },
    );
  });
});
